export default "__VITE_ASSET__t5znAgGz__"